import {
  TListingFetchReason,
  TRESPONSE_GET_NEEDLE_REQUESTS,
  TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST,
  TRESPONSE_NEEDLE_LIST,
  TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TNeedleManagementState = {
  needleListingInfo: {
    res: TRESPONSE_NEEDLE_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  needleListDropdownInfo: TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN | null;
  needleRequests: {
    res: TRESPONSE_GET_NEEDLE_REQUESTS;
    fetchReason: TListingFetchReason;
  } | null;
  localStoreNeedleRequests: {
    res: TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST;
    fetchReason: TListingFetchReason;
  } | null;
  needleListingPagination: TUserPaginationOption;
  needleRequestPagination: TUserPaginationOption;
  localNeedleRequestPagination: TUserPaginationOption;
};

export const TNeedleManagementInfoActionType = {
  GetNeedleList: 'GET_NEEDLE_LIST' as const,
  GetNeedleListSuccess: 'GET_NEEDLE_LIST_SUCCESS' as const,
  GetNeedleListFailure: 'GET_NEEDLE_LIST_FAILURE' as const,
  SetNeedleListPagination: 'SET_NEEDLE-LIST_PAGINATION' as const,
  GetNeedleListDropdown: 'GET_NEEDLE_LIST_DROPDOWN' as const,
  GetNeedleListDropdownSuccess: 'GET_NEEDLE_LIST_DROPDOWN_SUCCESS' as const,
  GetNeedleListDropdownFailure: 'GET_NEEDLE_LIST_DROPDOWN_FAILURE' as const,
  UpdateNeedle: 'UPDATE_NEEDLE' as const,
  UpdateNeedleFailure: 'UPDATE_NEEDLE_SUCCESS' as const,
  UpdateNeedleSuccess: 'UPDATE_NEEDLE_FAILURE' as const,
  DeleteNeedle: 'DELETE_NEEDLE' as const,
  DeleteNeedleSuccess: 'DELETE_NEEDLE_SUCCESS' as const,
  DeleteNeedleFailure: 'DELETE_NEEDLE_FAILURE' as const,
  RaiseNeedleRequest: 'RAISE_NEEDLE_REQUEST' as const,
  RaiseNeedleRequestSuccess: 'RAISE_NEEDLE_REQUEST_SUCCESS' as const,
  RaiseNeedleRequestFailure: 'RAISE_NEEDLE_REQUEST_FAILURE' as const,
  GetNeedleRequestList: 'GET_NEEDLE_REQUEST_LIST' as const,
  SetNeedleRequestPagination: 'SET_NEEDLE-REQUEST_PAGINATION' as const,
  GetNeedleRequestListSuccess: 'GET_NEEDLE_REQUEST_LIST_SUCCESS' as const,
  GetNeedleRequestListFailure: 'GET_NEEDLE_REQUEST_LIST_FAILURE' as const,
  BulkUpdateNeedleRequest: 'BULK_UPDATE_NEEDLE_REQUEST' as const,
  BulkUpdateNeedleRequestSuccess: 'BULK_UPDATE_NEEDLE_REQUEST_SUCCESS' as const,
  BulkUpdateNeedleRequestFailure: 'BULK_UPDATE_NEEDLE_REQUEST_FAILURE' as const,
  ApproveNeedleRequest: 'APPROVE_NEEDLE_REQUEST' as const,
  ApproveNeedleRequestSuccess: 'APPROVE_NEEDLE_REQUEST_SUCCESS' as const,
  ApproveNeedleRequestFailure: 'APPROVE_NEEDLE_REQUEST_FAILURE' as const,
  SetLocalNeedleRequestPagination: 'SET_LOCAL-NEEDLE-REQUEST_PAGINATION' as const,
  GetLocalStoreRequests: 'GET_LOCAL_STORE_REQUESTS' as const,
  GetLocalStoreRequestsSuccess: 'GET_LOCAL_STORE_REQUESTS_SUCCESS' as const,
  GetLocalStoreRequestsFailure: 'GET_LOCAL_STORE_REQUESTS_FAILURE' as const,
};
